import { APICONSTANTS } from '../../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { SocieteLinkedService } from '../societe-linked/societe-linked.service';
import { CycleBpModel } from '../../models/societe-linked/bp/cycle-bp.model';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class CycleBpService extends SocieteLinkedService<CycleBpModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTECYCLEBP, hostnameService);
  }
  getAllFromBc(idBp: number): Observable<CycleBpModel[]> {
    return this.getAllbyId('getfromBp/', idBp);
  }

  getLastValideurs(idBp: number): Observable<CycleBpModel[]> {
    return this.getAllbyId('getLastValideurs/', idBp);
  }
}